// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CenterBlock_wrapper_U5opo"};